module.exports = __webpack_public_path__ + "static/media/microphone-black-shape.efe94db4.svg";